import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl, defineMessages, FormattedMessage, FormattedDate } from 'react-intl';

import { withRtl } from '../../../components/hoc';
import messages from '../../../locale/messages';
import { formatTime, customisedIntlFormatMessage } from '../../../utils/helpers';
import style from './Appointment.scss'; // eslint-disable-line css-modules/no-unused-class
import Button from '../../../components/Button';
import MusicIcon from '../../../components/icons/Music';
import { LA_GUARDIA_DBN } from '../../../constants';

/* eslint-disable css-modules/no-undef-class */
const localMessages = defineMessages({
  appointmentFor: {
    id: 'schedule.appointment.For',
    defaultMessage: '{label} for',
    description: 'The schedule appointment for string',
    values: { label: 'Appointment' },
  },
  appointmentLocation: {
    id: 'schedule.appointment.Location',
    defaultMessage: '{label} Location',
    description: 'The schedule appointment location string',
    values: { label: 'Appointment' },
  },
  expressionOfInterest: {
    id: 'schedule.expressionOfInterest',
    defaultMessage: 'Expression of interest',
    description: 'The schedule expression of interest string',
  },
  expressionOfInterestLaGuardia: {
    id: 'schedule.expressionOfInterestLaGuardia',
    defaultMessage: 'Registered for audition',
    description: 'The schedule registered for audition string',
  },
  // expressionOfInterestMiddleSchool: {
  //   id: 'schedule.expressionOfInterest.MiddleSchool',
  //   defaultMessage: 'Registered (you must still <a href="{applyLink}">apply</a>)',
  //   description: 'Expressed interest title for middle school',
  // },
  expressionOfInterestMiddleSchoolPostDeadline: {
    id: 'schedule.expressionOfInterest.MiddleSchoolPostDeadline',
    defaultMessage: 'Registered',
    description: 'Expressed interest title for middle school',
  },
  expressionOfInterestFor: {
    id: 'schedule.ExpressionOfInterest.For',
    defaultMessage: 'For school and program',
    description: 'The schedule expression of interest for string',
  },
  expressionOfInterestLocation: {
    id: 'schedule.expressionOfInterest.Location',
    defaultMessage: 'Located at',
    description: 'The schedule expression of interest location string',
  },
  expressionOfInterestMiddleSchoolTalentTest: {
    id: 'schedule.expressionOfInterest.MiddleSchoolTalentTest',
    defaultMessage: 'Talent test for',
    description: 'The middle school schedule expression of interest test string',
  },
  noMatchingTimeSlotTitle: {
    id: 'schedule.noMatchingTimeSlot.Title',
    defaultMessage:
      'You will be given a test date and time on your test ticket. Test tickets will be available in October.',
    description: 'Title used for no mathcing time slots',
  },
  testScoreEligibility: {
    id: 'schedule.shared.testScoreEligibility',
    defaultMessage: 'Your score on this test makes you eligible for all {label} Programs',
    description:
      'Message that states that this test score makes a student eligible to enter any program in that admission process',
    values: { label: 'Specialized High School' },
  },
  testScoreEligibilityLGA: {
    id: 'schedule.shared.testScoreEligibilityLGA',
    defaultMessage:
      'Your score on this test makes you eligible for all Fiorello H. Laguardia High School Of Music & Art Programs that you have registered for',
    description:
      'Message that states that this test score makes a student eligible to enter any program in the LGA admission process',
  },
  testScoreEligibilityGT: {
    id: 'schedule.shared.testScoreEligibilityGT',
    defaultMessage: 'Your score on this test determines your eligibility for G&T (K,1,2,3) Programs',
    description:
      'Message that states that this test score makes a student eligible to enter any program in that admission process',
  },
  addToCalendar: {
    id: 'schedule.addToCalendar',
    defaultMessage: 'Add to calendar',
    description: 'String describing calendar icon on scheduled appointments',
  },
  appointmentTitleButton: {
    id: 'schedule.appointmentTitleButton',
    defaultMessage: 'Opens program details',
    description: 'Add additional information to appointment title button',
  },
  laguardiaTicketTitle: {
    id: 'schedule.laguardiaTicketTitle',
    defaultMessage: 'LaGuardia Ticket (for all scheduled auditions):',
    description: 'Title for Laguardia test tickets',
  },
  ticketButton: {
    id: 'schedule.ticketButton',
    defaultMessage: 'Download & Print Ticket',
    description: 'Text for the download ticket button',
  },
});

class Appointment extends React.PureComponent {
  showProgramDetail = (directoryProgramId, directorySchoolId) => {
    if (this.props.programClickAppointment) {
      this.props.programClickAppointment(directoryProgramId, directorySchoolId);
    }
  };

  goToTicket = () => {
    const { ticket } = this.props;
    window.location = `${ticket.ticket_url}`;
  };

  renderAppointmentDate = () => {
    const { appointmentDate, intl, isGT, isMS } = this.props;

    if (appointmentDate && !isMS) {
      return (
        <Fragment>
          <FormattedDate value={appointmentDate} />
          &nbsp;
          {formatTime(appointmentDate)}
        </Fragment>
      );
    }
    if (isGT || isMS) {
      return null;
    }
    return <Fragment>{customisedIntlFormatMessage(intl, localMessages.noMatchingTimeSlotTitle)}</Fragment>;
  };
  renderEligibilty = () => {
    const { program, isGT, isSHS, isExpressionOfInterest } = this.props;

    if (isGT) {
      return (
        <div className={style.scheduleAppointmentFor}>
          <FormattedMessage {...localMessages.testScoreEligibilityGT} />
        </div>
      );
    }

    if (program.school.dbn === LA_GUARDIA_DBN && isSHS && !isExpressionOfInterest) {
      return (
        <div className={style.scheduleAppointmentFor}>
          <FormattedMessage {...localMessages.testScoreEligibilityLGA} />
        </div>
      );
    }

    if (program.is_shared) {
      return (
        <div className={style.scheduleAppointmentFor}>
          <FormattedMessage
            {...localMessages.testScoreEligibility}
            values={{ label: program.admission_process.name }}
          />
        </div>
      );
    }
    return (
      <div className={style.scheduleAppointmentFor}>
        <div className={style.scheduleAppointmentForSchool}>{program.school.name}</div>
        <div className={style.scheduleAppointmentForProgram}>{program.name}</div>
      </div>
    );
  };

  renderMiddleSchoolTalentTests = () => {
    const { isMS, appointmentDate } = this.props;
    if (isMS && appointmentDate) {
      return null;
    }
    return (
      <Fragment>
        <div className={style.scheduleMstalentTitle}>
          {customisedIntlFormatMessage(this.props.intl, localMessages.expressionOfInterestMiddleSchoolTalentTest)}
        </div>
        <div>
          <span className={style.scheduleMstalentIcon}>
            <MusicIcon size={16} />
          </span>
          <span>{this.props.program.admission_method.name}</span>
        </div>
      </Fragment>
    );
  };

  render() {
    const {
      program,
      isExpressionOfInterest,
      isNoMatchingTimeSlot,
      selected,
      location,
      intl,
      isSHS,
      isMS,
      ticket,
    } = this.props;
    const appointmentClasses = [style.scheduleAppointmentContainer];

    if (selected) {
      appointmentClasses.push(style.scheduleAppointmentContainerSelected);
    }

    let scheduleAppointmentTitle;
    let scheduleAppointmentLocation;
    if (program.is_shared) {
      scheduleAppointmentTitle = program.admission_method.name;
      scheduleAppointmentLocation = (
        <FormattedMessage {...localMessages.appointmentLocation} values={{ label: 'Test' }} />
      );
    } else {
      scheduleAppointmentTitle = (
        <FormattedMessage {...localMessages.appointmentFor} values={{ label: program.admission_method.name }} />
      );
      scheduleAppointmentLocation = (
        <FormattedMessage {...localMessages.appointmentLocation} values={{ label: program.admission_method.name }} />
      );
    }

    let isSHSLaGuardia = false;
    if (program.school.dbn === LA_GUARDIA_DBN && isSHS) {
      isSHSLaGuardia = true;
    }

    let expressionOfInterestTitle;
    if (isSHSLaGuardia) {
      expressionOfInterestTitle = localMessages.expressionOfInterestLaGuardia;
    } else if (isMS) {
      expressionOfInterestTitle = localMessages.expressionOfInterestMiddleSchoolPostDeadline;
    } else {
      expressionOfInterestTitle = localMessages.expressionOfInterest;
    }

    return (
      <div className={classNames(...appointmentClasses)}>
        <div className={style.scheduleAppointment}>
          <div className={style.scheduleAppointmentTop}>
            <div className={style.scheduleAppointmentStart}>
              {ticket.show_tickets &&
                !this.props.hideTicket && (
                  <div className={style.scheduleAppointmentTicket}>
                    {isSHSLaGuardia ? (
                      <h3>
                        <FormattedMessage {...localMessages.laguardiaTicketTitle} />
                      </h3>
                    ) : (
                      <h3>{ticket.ticket_label}</h3>
                    )}
                    <Button
                      label={customisedIntlFormatMessage(intl, localMessages.ticketButton)}
                      ariaLabel={customisedIntlFormatMessage(intl, localMessages.ticketButton)}
                      onClick={this.goToTicket}
                    />
                  </div>
                )}
              <button
                disabled={!program || program.is_shared}
                className={
                  isMS ? classNames('button--no-style', style.scheduleMstalentTitleButton) : 'button--no-style'
                }
                onClick={() =>
                  this.showProgramDetail(program.directory_program.id, program.directory_program.directory_school_id)
                }
              >
                {isExpressionOfInterest ? (
                  <div>
                    {isMS ? (
                      <FormattedMessage
                        {...expressionOfInterestTitle}
                        values={{ applyLink: window.location.href.replace('schedule', 'apply') }}
                        tagName="h4"
                      />
                    ) : (
                      <FormattedMessage {...expressionOfInterestTitle} tagName="h4" />
                    )}
                  </div>
                ) : (
                  <h4>{this.renderAppointmentDate()}</h4>
                )}
                {!program.is_shared && (
                  <span className="visually-hidden">{customisedIntlFormatMessage(intl, localMessages.appointmentTitleButton)}</span>
                )}
              </button>
            </div>
          </div>
          {!isExpressionOfInterest &&
            (!isMS || !this.props.appointmentDate) && (
              <div className={style.scheduleAppointmentTitle}>{scheduleAppointmentTitle}</div>
            )}
          {isMS ? this.renderMiddleSchoolTalentTests() : this.renderEligibilty()}
          {(!isExpressionOfInterest || (isExpressionOfInterest && isMS)) &&
            (!isMS || !this.props.appointmentDate) &&
            !isNoMatchingTimeSlot && (
              <div>
                <div className={style.scheduleAppointmentTitle}>{scheduleAppointmentLocation}</div>
                <div className={style.scheduleAppointmentLocationContainer}>
                  <div>
                    <span className={style.scheduleAppointmentLocationIcon}>
                      <i className="icon-Map-Pin" />
                    </span>
                  </div>
                  <div>
                    {location ? (
                      <a
                        className={style.scheduleAppointmentLocationLink}
                        target="_blank"
                        rel="noopener"
                        href={encodeURI(`https://maps.google.com?q=${location}`)}
                      >
                        {isMS && <div>{program.school.name}</div>}
                        <span aria-hidden>{location}</span>
                        <span className="visually-hidden">{`${location}, ${customisedIntlFormatMessage(intl, 
                          messages.opensInNewWindow,
                        )}`}</span>
                      </a>
                    ) : (
                      <FormattedMessage {...messages.generalStringNotKnownYet} />
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

Appointment.defaultProps = {
  location: null,
  selected: false,
  appointmentDate: null,
  isExpressionOfInterest: false,
  isNoMatchingTimeSlot: false,
  isRtl: false,
  programClickAppointment: null,
  hideTicket: false,
  isMS: false,
  ticket: {
    show_tickets: null,
    ticket_url: null,
    ticket_label: null,
  },
};

Appointment.propTypes = {
  program: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  location: PropTypes.string,
  appointmentDate: PropTypes.string,
  isExpressionOfInterest: PropTypes.bool,
  isNoMatchingTimeSlot: PropTypes.bool,
  selected: PropTypes.bool,
  showSchoolDetail: PropTypes.func.isRequired,
  programClickAppointment: PropTypes.func,
  isRtl: PropTypes.bool,
  intl: PropTypes.shape().isRequired,
  isSHS: PropTypes.bool.isRequired,
  isGT: PropTypes.bool.isRequired,
  isMS: PropTypes.bool,
  hideTicket: PropTypes.bool, // Used to show only a single Laguardia instance
  ticket: PropTypes.shape({
    show_tickets: PropTypes.bool,
    ticket_url: PropTypes.string,
    ticket_label: PropTypes.string,
  }),
};

export default withRtl(style)(injectIntl(withStyles(style)(Appointment)));
